import React, { useState } from 'react';
import { theme } from '../../../../shared/lib/styles';

const OrderEventsQuestion = ({ question, onAnswer, answered }) => {
    const [order, setOrder] = useState(() => question.items.map((_, i) => i));

    const move = (index, dir) => {
        if (answered) return;
        const next = [...order];
        const swap = index + dir;
        if (swap < 0 || swap >= next.length) return;
        [next[index], next[swap]] = [next[swap], next[index]];
        setOrder(next);
    };

    const check = () => {
        if (answered) return;
        const correct = order.every((v, i) => v === question.correctOrder[i]);
        onAnswer(correct);
    };

    return (
        <div>
            <div style={styles.list}>
                {order.map((itemIndex, pos) => (
                    <div key={itemIndex} style={styles.row}>
                        <span style={styles.num}>{pos + 1}</span>
                        <span style={styles.text}>{question.items[itemIndex]}</span>
                        <div style={styles.arrows}>
                            <button
                                type="button"
                                disabled={answered || pos === 0}
                                onClick={() => move(pos, -1)}
                                style={styles.arrowBtn}
                                aria-label="Вверх"
                            >
                                ▲
                            </button>
                            <button
                                type="button"
                                disabled={answered || pos === order.length - 1}
                                onClick={() => move(pos, 1)}
                                style={styles.arrowBtn}
                                aria-label="Вниз"
                            >
                                ▼
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            {!answered && (
                <button type="button" onClick={check} style={styles.checkBtn}>
                    Проверить порядок
                </button>
            )}
        </div>
    );
};

const styles = {
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.sm,
        marginBottom: theme.spacing.lg,
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,
        padding: theme.spacing.md,
        backgroundColor: theme.colors.bgLight,
        borderRadius: theme.borderRadius.md,
    },
    num: {
        fontWeight: theme.fontWeight.bold,
        minWidth: 28,
        color: theme.colors.primary,
    },
    text: {
        flex: 1,
        fontSize: theme.fontSize.base,
    },
    arrows: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    arrowBtn: {
        padding: '4px 10px',
        fontSize: theme.fontSize.sm,
        cursor: 'pointer',
        borderRadius: theme.borderRadius.sm,
        border: `1px solid ${theme.colors.borderMedium}`,
        background: '#fff',
    },
    checkBtn: {
        padding: `${theme.spacing.md} ${theme.spacing.xl}`,
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.bold,
        backgroundColor: theme.colors.primary,
        color: '#fff',
        border: 'none',
        borderRadius: theme.borderRadius.lg,
        cursor: 'pointer',
        width: '100%',
    },
};

export default OrderEventsQuestion;
